import React from 'react';
import { isMobile } from 'react-device-detect';

import SelectDesktop from './selectAutoComplete';
import SelectMobile from './selectMenuNative';

const SelectMenu = () => (isMobile ? <SelectMobile /> : <SelectDesktop />);

export default SelectMenu;
